import React, {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'
import { DatePicker } from 'antd'
import moment from 'moment'
import { CellBox } from 'Components/DossierUnico/DossierUnicoData'

const AgDateCellEditor = memo(
  forwardRef((props, ref) => {
    const { value: initialValue, colDef } = props
    const { cellEditorParams } = colDef
    const [value, setValue] = useState(
      moment(initialValue).isValid() ? moment(initialValue) : null,
    )
    const refInput = useRef(null)

    useEffect(() => {
      refInput.current.focus()
    }, [])

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value
            ? value.toISOString()
            : null
        },
        isCancelBeforeStart() {
          return cellEditorParams?.isCancelBeforeStart?.(props) ?? false
        },
        isCancelAfterEnd() {
          return cellEditorParams?.isCancelAfterEnd?.(props) ?? false
        },
      }
    })

    return (
      <CellBox>
        <DatePicker
          onChange={setValue}
          value={value}
          ref={refInput}
          style={{ width: '100%' }}
          format={cellEditorParams?.format ?? 'DD/MM/YYYY'}
          disabledDate={current =>
            cellEditorParams?.disabledDate?.(current, props)
          }
        />
      </CellBox>
    )
  }),
)

export default AgDateCellEditor;
